import { cn } from '@/lib/utils';

type StatusCategory = 'booking' | 'room' | 'task' | 'channel';

const BOOKING_STATUS_STYLES: Record<string, { bg: string; text: string; label: string }> = {
  confirmed: { bg: 'bg-green-100', text: 'text-green-700', label: 'Confirmed' },
  pending: { bg: 'bg-yellow-100', text: 'text-yellow-800', label: 'Pending' },
  checked_in: { bg: 'bg-blue-100', text: 'text-blue-700', label: 'Checked In' },
  checked_out: { bg: 'bg-gray-100', text: 'text-gray-600', label: 'Checked Out' },
  cancelled: { bg: 'bg-red-100', text: 'text-red-700', label: 'Cancelled' },
};

const ROOM_STATUS_STYLES: Record<string, { bg: string; text: string; label: string }> = {
  clean: { bg: 'bg-green-100', text: 'text-green-700', label: 'Clean' },
  dirty: { bg: 'bg-red-100', text: 'text-red-700', label: 'Dirty' },
  inspected: { bg: 'bg-blue-100', text: 'text-blue-700', label: 'Inspected' },
  occupied: { bg: 'bg-purple-100', text: 'text-purple-700', label: 'Occupied' },
  maintenance: { bg: 'bg-amber-100', text: 'text-amber-700', label: 'Maintenance' },
  out_of_order: { bg: 'bg-gray-100', text: 'text-gray-600', label: 'Out of Order' },
};

const TASK_STATUS_STYLES: Record<string, { bg: string; text: string; label: string }> = {
  pending: { bg: 'bg-yellow-100', text: 'text-yellow-800', label: 'Pending' },
  in_progress: { bg: 'bg-blue-100', text: 'text-blue-700', label: 'In Progress' },
  completed: { bg: 'bg-green-100', text: 'text-green-700', label: 'Completed' },
};

const CHANNEL_STATUS_STYLES: Record<string, { bg: string; text: string; label: string }> = {
  success: { bg: 'bg-green-100', text: 'text-green-700', label: 'Success' },
  failed: { bg: 'bg-red-100', text: 'text-red-700', label: 'Failed' },
  partial: { bg: 'bg-yellow-100', text: 'text-yellow-700', label: 'Partial' },
  connected: { bg: 'bg-green-100', text: 'text-green-700', label: 'Connected' },
  disconnected: { bg: 'bg-gray-100', text: 'text-gray-500', label: 'Disconnected' },
};

const STATUS_MAP: Record<StatusCategory, Record<string, { bg: string; text: string; label: string }>> = {
  booking: BOOKING_STATUS_STYLES,
  room: ROOM_STATUS_STYLES,
  task: TASK_STATUS_STYLES,
  channel: CHANNEL_STATUS_STYLES,
};

interface StatusBadgeProps {
  status: string;
  category?: StatusCategory;
  label?: string;
  className?: string;
}

export function StatusBadge({ status, category = 'booking', label, className }: StatusBadgeProps) {
  const styles = STATUS_MAP[category]?.[status] ?? { bg: 'bg-gray-100', text: 'text-gray-600', label: status };
  const displayLabel = label ?? styles.label;

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-3 py-1 text-xs font-medium tap-auto',
        styles.bg,
        styles.text,
        className,
      )}
    >
      {displayLabel}
    </span>
  );
}
